import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
var _excluded = ["controlsRef", "domNodeRef", "className"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { animated, config as springConfig, useSpring } from 'react-spring';
import { CustomPropTypes } from '@beef/react';
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
var fillRef = function fillRef(ref, data) {
  if (_typeof(ref) === 'object') {
    ref.current = data; // eslint-disable-line no-param-reassign
  } else if (typeof ref === 'function') {
    ref(data);
  }
};

/**
 * A super simple spring-based ScrollContainer, that provides it`s interfaces via `controlsRef`
 */
export default function SpringContainer(_ref) {
  var controlsRef = _ref.controlsRef,
    domNodeRef = _ref.domNodeRef,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useSpring = useSpring(function () {
      return {
        config: _objectSpread(_objectSpread({}, springConfig.slow), {}, {
          precision: 3
        }),
        scroll: 0
      };
    }),
    _useSpring2 = _slicedToArray(_useSpring, 3),
    scroll = _useSpring2[0].scroll,
    startScroll = _useSpring2[1],
    stop = _useSpring2[2];
  var getScroll = function getScroll() {
    return domNodeRef.current.scrollLeft;
  };
  function scrollTo(position) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$immediate = _ref2.immediate,
      immediate = _ref2$immediate === void 0 ? false : _ref2$immediate,
      _ref2$config = _ref2.config,
      config = _ref2$config === void 0 ? springConfig.slow : _ref2$config;
    return new Promise(function (resolve) {
      startScroll(_objectSpread({
        immediate: immediate
      }, immediate ? {
        scroll: position
      } : {
        to: function () {
          var _to = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(next) {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return next({
                    scroll: position
                  });
                case 2:
                  resolve();
                case 3:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          }));
          function to(_x) {
            return _to.apply(this, arguments);
          }
          return to;
        }(),
        config: config,
        reset: true,
        from: {
          scroll: getScroll()
        }
      }));
    });
  }
  var stopScroll = function stopScroll() {
    return stop(true);
  };

  /** provide scrollContainer interface to the SpringContainer */
  fillRef(controlsRef, {
    scrollTo: scrollTo,
    stopScroll: stopScroll,
    getScroll: getScroll
  });
  return /*#__PURE__*/React.createElement(animated.div, _extends({}, otherProps, {
    className: cx('container', className),
    ref: domNodeRef,
    scrollLeft: scroll
  }));
}
SpringContainer.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Spring way of passing controls up to another component,
   * this low level function returns three methods to control scroll:
   * - scrollTo, stopScroll and getScroll
   */
  controlsRef: CustomPropTypes.ref,
  /** common props */
  domNodeRef: CustomPropTypes.ref.isRequired,
  children: PropTypes.node,
  className: PropTypes.string
} : {};